const PRESERVED_PARAMS = ['company'];
const INBOUND_PARAMS = ['company', 'session_id'];

/**
 * Build a search string that keeps company for normal navigation.
 * @param {URLSearchParams} searchParams
 * @returns {string} Search string including leading `?`, or empty string
 */
export function preservedSearch(searchParams) {
  return searchFromKeys(searchParams, PRESERVED_PARAMS);
}

/**
 * Build a search string that keeps company and session_id for inbound redirects.
 * @param {URLSearchParams} searchParams
 * @returns {string} Search string including leading `?`, or empty string
 */
export function inboundSearch(searchParams) {
  return searchFromKeys(searchParams, INBOUND_PARAMS);
}

/**
 * Join a pathname with the preserved company query param.
 * @param {string} pathname
 * @param {URLSearchParams} searchParams
 * @returns {string}
 */
export function pathWithPreservedParams(pathname, searchParams) {
  return `${pathname}${preservedSearch(searchParams)}`;
}

/**
 * Copy selected query keys into a search string.
 * @param {URLSearchParams} searchParams
 * @param {string[]} keys
 * @returns {string}
 */
function searchFromKeys(searchParams, keys) {
  const next = new URLSearchParams();
  for (const key of keys) {
    const value = searchParams.get(key);
    if (value) next.set(key, value);
  }
  const serialized = next.toString();
  return serialized ? `?${serialized}` : '';
}
